import ApiService from "@/services/Api"

export type BlockWabaContactInput = {
	clientId: number
	inboxChannelId: number
}

export type UnblockWabaContactInput = {
	clientId: number
	inboxChannelId: number
}

class WABAContactService {
	async blockWabaContact (input: BlockWabaContactInput) {
		await ApiService.put(`/waba/channel/${input.inboxChannelId}/block/contact/${input.clientId}`)
	}

	async unblockWabaContact (input: UnblockWabaContactInput) {
		await ApiService.put(`/waba/channel/${input.inboxChannelId}/unblock/contact/${input.clientId}`)
	}
}
export default new WABAContactService()
